import React from 'react'
import { Row, Col } from 'react-bootstrap'
import { IHomeData } from '../../types/api/homeApi'
import { NoData } from '../common/NoData'
import { Link } from 'react-router-dom'
import { useTranslation } from 'react-i18next';

const Aboutus: React.FC<{ home_data: IHomeData }> = ({ home_data }) => {
    const { t, i18n } = useTranslation();
    
    // console.log(t(),'ggggg');
    // console.log(typeof t,'ggg');
    const facilities = t('home.about_us.facility', { returnObjects: true })  as string[];
    return (
        <section className='aboutus inner-padding'>
            <div className='container'>
                <Row>
                    <Col md={12} lg={6}>
                        <div className='about-left' >
                            <div className='about-image'>
                                <img src={require('../../assets/images/about-01.jpg')} alt='demo' />
                                <img src={require('../../assets/images/about-02.jpg')} alt="demo-01" className='ab-img' />
                                <div className='video-btn'>
                                    <Link to="#" className='play-btn'><img src={require('../../assets/images/play.png')} alt='demo' /></Link>
                                </div>
                            </div>
                            <div className='about-title-box'>
                                <img src={require('../../assets/images/interior-design.png')} alt='demo' />
                                <h5>{t('home.about_us.luxury_room')}</h5>
                                <p>{t('home.about_us.left_description')}</p>
                            </div>
                        </div>
                    </Col>
                    <Col md={12} lg={6}>
                        <div className='about-right' >
                            <div className='about-right-title'>
                                {/* <h4 className='title-highlight'>Get About Us</h4> */}
                                <h4 className="sub-title">{t('home.about_us.get_about_us')}</h4>
                                <h3 className="title">{t('home.about_us.right_title')}</h3>
                            </div>
                            {/* <h3>{t('home.about_us.right_title')}</h3> */}
                            <p>{t('home.about_us.right_description')}</p>
                            <ul>
                                {home_data && home_data.aboutUs && home_data.aboutUs.facility && home_data.aboutUs.facility.length ?
                                    home_data.aboutUs.facility.map((fac: string, index: number) => (
                                        <li key={"facility_" + index}>
                                            <div className='about-icon'>
                                                <img src={require('../../assets/images/ab-01.png')} alt='demo' />
                                            </div>
                                            <h5>{facilities[index]}</h5>
                                        </li>
                                    ))
                                    : <NoData message='Oops,No Facility Data Found!!' />}
                            </ul>
                            <Link to={home_data && home_data.aboutUs && home_data.aboutUs.link} className='btn btn-gold'>{t('home.about_us.read_more')} <img src={require('../../assets/images/right.png')} alt='demo' /></Link>
                        </div>
                    </Col>
                </Row>
            </div>
        </section>
    )
}

export default Aboutus;